import authFetch from './fetch';
import { getQueryParams, makeRequest } from './utils';

export const getTraceLocations = async (pronumber) => {
  try {
    const response = await authFetch.get(`/api/Tracing/OrderLocations?pronumber=${pronumber}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const executeImportTrace = (params) => {
  return makeRequest(authFetch.post(`/api/Tracing/ClickTraceImport`, params));
};
export const executeExportTrace = (params) => {
  return makeRequest(authFetch.post(`/api/Tracing/ClickTraceExport`, params));
};

export const getAvailableTraces = () => makeRequest(authFetch.get('/api/Tracing/AvailableTraces'));
export const getAvailableTracesLookup = () => makeRequest(authFetch.get('/api/Tracing/AvailableTraces/Lookup'));
export const getAvailableTracesGrid = (params) =>
  makeRequest(authFetch.get(`/api/Tracing/AvailableTracesGrid${getQueryParams(params)}`));
export const getAvailableTrace = (id) => makeRequest(authFetch.get(`/api/Tracing/AvailableTraces/${id}`));
export const putAvailableTrace = (data) => makeRequest(authFetch.put('/api/Tracing/AvailableTraces', data));
export const getAvailableTracesSearchProperties = () => makeRequest(authFetch.get('/api/Tracing/SearchProperties'));
export const restoreAvailableTrace = (id) => makeRequest(authFetch.patch(`/api/Tracing/AvailableTraces/${id}/Restore`));
export const deleteAvailableTrace = (id) => makeRequest(authFetch.delete(`/api/Tracing/AvailableTraces/${id}`));
export const getAvailableTraceTypes = () => makeRequest(authFetch.get('/api/Tracing/AvailableTraces/Types'));
